var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('loading',{attrs:{"name":"load news detail"}},[_c('div',{staticClass:"container news fix-footer"},[_c('div',{staticClass:"row mt-3"},[_c('news-item'),_c('side-panel-news')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }